import store from '@/store'

import { API_BASE, apiErrorHandler, ApiFilter } from '../api'
import Auth from '../auth'

const FAQ_ENDPOINT = `${API_BASE}faqs/`

export default class FAQAPI {
  constructor(cls) {
    this.cls = cls
  }
  static create(cls) {
    return new FAQAPI(cls)
  }

  getTcOrTaxFaq(org_name, context) {
    // context param should be either 'tc' or 'tax_q'
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = store.state.axiosApi.get(FAQ_ENDPOINT + `get_faq?org=${org_name}&${context}=true`, options)
    return promise
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'Get T&C or Tax Question FAQ API Error' }))
  }

  list({ pagination, filters }) {
    const filtersMap = {
      // Pagination
      page: ApiFilter.create({ key: 'page' }),
      pageSize: ApiFilter.create({ key: 'page_size' }),

      // Sorting
      ordering: ApiFilter.create({ key: 'ordering' }),

      //
      request: ApiFilter.create({ key: 'request' }),
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },

      params: ApiFilter.buildParams(filtersMap, { ...pagination, ...filters }),
    }

    const promise = store.state.axiosApi.get(FAQ_ENDPOINT, options)
    return promise
      .then(res => ({
        ...res.data,
        results: res.data.results.map(this.cls.fromAPI),
      }))
      .catch(apiErrorHandler({ apiName: 'List FAQ API Error' }))
  }
}
